import { render, staticRenderFns } from "./animated-placeholder.vue?vue&type=template&id=b50800fc&scoped=true"
import script from "./animated-placeholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./animated-placeholder.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./animated-placeholder.vue?vue&type=style&index=0&id=b50800fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50800fc",
  null
  
)

export default component.exports